// import { API_CONFIG } from '../config.js';

export default {
	postUploadFile: function ({ commit }, postURL, formData) {
		var langCode = formData.get('language_code');
		return axios.post(postURL, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			},
			onUploadProgress: function (progressEvent) {
				// console.log('progressEvent: ', progressEvent);
				var uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total));
				commit('setUploadProgress', { lang_code: langCode, progress: uploadPercentage });
			}.bind(this)
		});
	},

	/* DELETE	/api/v1/project/{projectID} */
	deleteFile: function (fileID) {
		// Vue.InfoSwal('[API CALL] deleteFile (' + fileID + ')');
		return axios.delete('/files/' + fileID);
	}
};
